// extracted by mini-css-extract-plugin
export default {"controls":"_7m+soXkBnapLILCVFYOTHw==","back-button":"_7+l+pYrg8DlGGkiua-QOfA=="};